// CORE-1435 — на каких экранах тур вправе появляться. Чистые решения без
// React, чтобы их было видно в тесте.
//
// Тур — экскурсия по главной: все якоря подсветки живут там. Автозапуск же не
// смотрел на маршрут, и человек, вошедший по ссылке на Live, через секунду
// получал затемнение на весь экран поверх «Присоединиться». Затемнение глотало
// каждое касание — кнопка выглядела мёртвой, хотя вход был разрешён.

/** Главная — единственный экран, где тур запускается сам. */
export const TOUR_HOME_ROUTE = 'Home';

/** Экраны входа в Live: тур здесь только мешает войти. */
const LIVE_ENTRY_ROUTES: ReadonlySet<string> = new Set([
  'RoomAnnouncement',
  'LiveSessionEntry',
  'LiveRoomSession',
]);

/**
 * Можно ли автозапуску сработать на этом маршруте. Не главная — не отказ, а
 * «подождать»: запуск откладывается до захода на главную. Навигация ещё не
 * готова (`undefined`) — тоже ждём.
 */
export function canAutoLaunchTourOn(routeName: string | undefined): boolean {
  return routeName === TOUR_HOME_ROUTE;
}

/**
 * Стоит ли уже идущий тур на паузе. На входе в Live — да: человек попал туда
 * назад по истории или из уведомления, и ни затемнение, ни поп-ап Agapella с
 * рассказом о главной не должны закрывать ему кнопку входа. Пауза — не конец:
 * шаг сохраняется, и на главной тур продолжается с него же. Пока маршрут
 * неизвестен, поведение прежнее.
 */
export function isTourPausedOn(routeName: string | undefined): boolean {
  return routeName != null && LIVE_ENTRY_ROUTES.has(routeName);
}
